module.exports = __webpack_public_path__ + "img/t2.af70a11b.svg";